<template>
  <div class="wrapper-people">
    <div class="container-desc">
      <p>Quantas pessoas utilizam internet?</p>
      <img class="img" src="../../public/people.svg" />
      <img class="imgm" src="../../public/mobilepeople.svg" />
    </div>>
    <div class="container flex-end">
      <div>
        <button
          v-for="no in peopleNo"
          :class="{ btn: no.id == selected }"
          @click="
                        selected = no.id;
                        selectedPoint = no.point;
                        addPlan();
                    "
          v-bind:key="no.id"
          class="btn-number item"
        >{{ no.name }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "PeopleNo",
  props: ["points"],
  data: function() {
    return {
      selected: undefined,
      selectedPoint: undefined,
      peopleNo: [
        {
          name: "2",
          id: 0,
          point: this.points[0].item_points
        },
        {
          name: "3 a 4",
          id: 1,
          point: this.points[1].item_points
        },
        {
          name: "4 a 6",
          id: 2,
          point: this.points[2].item_points
        },
        {
          name: "6 a 8",
          id: 3,
          point: this.points[3].item_points
        },
        {
          name: "8 a 10",
          id: 4,
          point: this.points[4].item_points
        },
        {
          name: "10+",
          id: 5,
          point: this.points[5].item_points
        }
      ]
    };
  },
  methods: {
    addPlan() {
      this.$store.commit("ADD_PLAN", this.selectedPoint);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/style";

img {
  width: 120px;
  height: 50px;
}

.imgm {
  display: none;
}

.wrapper-people {
  padding: 1em;
}

.container {
  margin: 0 auto;
  display: flex;
  text-align: end;
}

.item {
  flex: 1;
  margin: 5px;
  text-align: center;
  font-size: 1.5em;
  margin-right: 8%;
  margin-bottom: 5%;
}

.item:nth-child(5) {
  margin-bottom: 0;
}
.item:nth-child(6) {
  margin-bottom: 0;
}
.flex-end {
  justify-content: flex-end;
}

.btn-number {
  background: $white 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 20px #6d4a914d;
  border-radius: 24px;
  width: 6rem;
  height: 122px;
  text-align: center;
  font-weight: Bold;
  font-size: 24px;
  font-family: "Open Sans";
  color: $light-orange;
  cursor: pointer;
}

button:hover {
  box-shadow: 0px 0px 10px #6d4a914d;
}

.btn {
  border: 4px solid #ffa25086;
  background: $purple 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 20px #4605894d;
  color: $white;
}

p {
  text-align: left;
  font-size: 21px;
  color: $light-orange;
  font-weight: 500;
  float: left;
}

@media only screen and (max-width: 600px) {
  .container {
    display: block;
    text-align: center;
  }
  .wrapper-people {
    margin-bottom: 2em;
  }

  .container-desc {
    display: flex;
  }

  .img {
    display: none;
  }

  .imgm {
    display: block;
  }

  .item {
    margin-bottom: 1em;
  }
  .item:nth-child(even) {
    margin-right: 0em;
  }

  p {
    border-bottom: 0;
    padding-bottom: 2em;
    margin-right: 0;
    text-align: center;
  }

  .btn-number {
    height: 122px;
    width: 100px;
  }
}

@media only screen and (min-width: 1024px) {
  .container-desc {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .wrapper-people {
    display: flex;
  }
  .btn-number {
    width: 5rem;
    height: 99px;
  }
}

@media only screen and (min-width: 1800px) {
  .container-desc {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .btn-number {
    width: 6rem;
    height: 90px;
  }
}

@media only screen and (min-width: 601px) and (max-width: 1024px) {
  .btn-number {
    width: 5rem;
    height: 4em;
  }
}
</style>
